var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"display":_vm.should_display,"onClose":_vm.onClose,"buttonPosition":"center","buttonYes":{ display: false },"buttonNo":{ display: true, content: 'Fermer' },"title":_vm.title}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"6","sm":"6"}},[_c('doughnut-chart',{attrs:{"styles":{ height: '300px' },"chart-data":_vm.data_main,"options":{
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            labels: {
              fontColor: '#ffffff'
            },
            position: 'left'
          }
        }}})],1),_c('v-col',{attrs:{"cols":"6","sm":"6"}},[_c('doughnut-chart',{attrs:{"styles":{ height: '300px' },"chart-data":_vm.data,"options":{
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            labels: {
              fontColor: '#ffffff'
            },
            position: 'right'
          }
        }}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }